import axios from 'axios';

export default function ({state}, val) {
    return new Promise((resolve, reject)=>{
        state.loadingReports.push(val.WebReportId);
        let url = val.Url.replace(/ /g, '').replace(/report\/report/g, 'report/GeneratedReport');
        axios({
            url,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            state.loadingReports = state.loadingReports.filter(i=>i!==val.WebReportId);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', val.Name.replace(/ /g, '_') +  '.' + val.ReportFormat);
            document.body.appendChild(link);
            link.click();
        });
    });
}